import { ScenarioApi } from './ScenarioApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { planning } from '../../../stores/store';
import { openModal } from 'svelte-modals';
import ModalInfo from '../../shared/Modals/ModalInfo.svelte';
import { _ } from 'svelte-i18n';

export async function setStartPlanning(scenarioId: number, planningStarted: boolean = false) {
    return ScenarioApi.setStartPlanning(get(api), scenarioId, planningStarted)
        .then(() => {
            get(planning).planningStarted = planningStarted;
        })
        .catch(err => {
            console.error(err);
            openModal(ModalInfo, { text: 'Failed to start planning. Try again.' });
        });
}

export async function resetAssignments(scenarioId: number, tacticalPlanId: number) {
    return ScenarioApi.resetAssignments(get(api), scenarioId, tacticalPlanId)
        .then(() => {
            console.log('Assignments reset');
        })
        .catch(err => {
            console.error(err);
            openModal(ModalInfo, { text: 'Failed to reset assignments. Try again.' });
        });
}
